module.exports = __webpack_public_path__ + "img/buy_super_zh.380c14ed.png";